import { render, staticRenderFns } from "./SessionTranscription.vue?vue&type=template&id=4f6a6074&scoped=true"
import script from "./SessionTranscription.vue?vue&type=script&lang=js"
export * from "./SessionTranscription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6a6074",
  null
  
)

export default component.exports